import router from "@/router";
export function navigateToRoot() {
    router.push("/");
}
export function goBack() {
    router.go(-1);
}
